import { useShow } from "@refinedev/core";
import { Show, DateField, NumberField } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
} from "components/detail";

export const CenterShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    아이러빗 시설 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    아이러빗 시설 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본 NumberField(천단위 구분자) 그대로 유지 */}
                        <FieldItem
                            label="Id"
                            value={
                                record?.id != null ? (
                                    <NumberField value={record.id} />
                                ) : undefined
                            }
                        />
                        <FieldItem label="이름" value={record?.name} />
                        {/* 원본 record?.address + " (" + record?.latitude + ", " + record?.longitude + ")" 기반.
                            address 없을 때 "undefined" 문자열 노출만 정리(허용된 표시 수정), 나머지 결과는 동일 */}
                        <FieldItem
                            label="주소"
                            span={2}
                            value={
                                record
                                    ? `${record.address ?? ""} (${record.latitude}, ${record.longitude})`
                                    : undefined
                            }
                        />
                        {/* 원본 record?.kindOf + " (" + record?.estType + ")" 결과 유지 */}
                        <FieldItem
                            label="종류"
                            value={
                                record
                                    ? `${record.kindOf} (${record.estType})`
                                    : undefined
                            }
                        />
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="상태" value={record?.status} />
                        {/* 원본이 실수로 status를 또 뿌렸음 — 원본과 동일하게 유지 */}
                        <FieldItem label="현재인원" value={record?.status} />
                        {/* 원본 삼항 그대로 유지 */}
                        <FieldItem
                            label="고유코드"
                            value={
                                record?.kindOf === "ChildHouse"
                                    ? record?.childHouseCode
                                    : record?.kindOf === "Kindergarten"
                                    ? record?.kindergartenCode
                                    : ""
                            }
                        />
                        {/* 원본 DateField(로케일 포맷) 그대로 유지 */}
                        <FieldItem
                            label="수정일"
                            value={
                                record?.updatedDate ? (
                                    <DateField value={record.updatedDate} />
                                ) : undefined
                            }
                        />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="관련 목록">
                    <FieldGrid columns={2}>
                        {/* 원본 <Link> to 문자열(필터 파라미터 포함) 그대로 */}
                        <FieldItem
                            label="소속 교사 목록"
                            value={
                                <RelatedLink
                                    to={`/teachers?filters[0][field]=centerId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem
                            label="등록 아이 목록"
                            value={
                                <RelatedLink
                                    to={`/children?filters[0][field]=centerId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=CENTER`}
                                    label="바로가기"
                                />
                            }
                        />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
